class MemberRenewalController {
    constructor($http, $window, $timeout) {
        'ngInject';
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.data = [];
        this.currentYear = new Date().getFullYear();
        this.context = 0;
        this.contextLastYear = 0;
        this.context2YrsAgo = 0;

        this.spinner = true;
        this.httpError = false;

        this.slickConfig = {
            enabled: true,
            dots: true,
            draggable: false,
            cssEase: 'linear',
            method: {}
        };
    }

    $onInit() {
        this.$timeout(() => {
            this.$http({
                url: '/api/chapterleader/getchaptersummary',
                method: 'GET'
            }).then((response) => {
                this.data = response.data;

                this.context = (this.data.MemberRenewalPercent.replace(/[^0-9.]/g, '') / 100) * 180;
                this.contextLastYear = (this.data.MemberRenewalPercentLastYear.replace(/[^0-9.]/g, '') / 100) * 180;
                this.context2YrsAgo = (this.data.MemberRenewalPercent2YrsAgo.replace(/[^0-9.]/g, '') / 100) * 180;

                this.spinner = false;
            }, (response) => {
                this.spinner = false;
                this.httpError = true;
            });
        }, 1000);
    }
}

export default MemberRenewalController;



// WEBPACK FOOTER //
// ./src/app/angular/member-renewal/member-renewal.controller.js